import React from "react";
import logoutConfirm from "../../assets/images/logout.png";

const LogoutModal = ({ show, handleLogout, handleClose }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="logout-icon">
          <img src={logoutConfirm} alt="Logout Icon" />
        </div>
        <div className="logout-text">Are you sure you want to Log Out?</div>
        <div className="modal-buttons">
          <button onClick={handleClose} className="no-btn">No</button>
          <button onClick={handleLogout} className="yes-btn">Yes</button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
